export const IMPORT_STATS_JOB_STATUS = {
	QUEUED: 'QUEUED',
	COMPLETED: 'COMPLETED',
	IN_PROGRESS: 'IN_PROGRESS',
	FAILED: 'FAILED',
	LEGACY: 'LEGACY',
};
